var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.93 566.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.05,269.29c.1-6,.13-15.18.13-19.7,0-39.47-1.35-71.93-18.32-100.52-12.5-21-31.15-39-53.94-51.82C331,84.88,306.16,78.06,283,78.06c-49.19,0-97.2,27.64-122.31,70.41-17.51,29.81-19,66.45-19,101.43,0,2,0,4.47-.08,7.14-.06,4.06-.12,8.51-.08,12.25H85V496.06H481.84V269.29ZM170,257.46c0-2.83.08-5.48.08-7.56,0-31.08,1.16-63.4,15.06-87.08C205,129.08,244.31,106.41,283,106.41c38.58,0,79.47,23.49,99.45,57.13,13.32,22.44,14.35,49.82,14.35,86.05,0,5.28,0,14.34-.14,19.7H170C169.9,265.92,170,261.49,170,257.46ZM453.5,467.72H113.34V297.64H453.5ZM297.59,354.33H269.24V425.2h28.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6f244fc9672fcaeb00792b6b81752b7d.svg";
export { ForwardRef as ReactComponent };